import { buildHeaders, buildUrl, buildRequest, fetchRequest } from '../../utils/apis/RestApi';
import { type HttpMethod } from '../../utils/apis/restApiUtils';

export const buildWorkshopV3Request = (url: string, method: HttpMethod): Promise<Response> => {
  const headers = buildHeaders(true);
  const urlbuilt = buildUrl('ICARE_BACK', url);
  const request = buildRequest(urlbuilt, method, headers);
  return fetchRequest(request);
};
